import { render, staticRenderFns } from "./refrigeracao.vue?vue&type=template&id=4fb69c42"
import script from "./refrigeracao.vue?vue&type=script&lang=js"
export * from "./refrigeracao.vue?vue&type=script&lang=js"
import style0 from "./refrigeracao.vue?vue&type=style&index=0&id=4fb69c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports